import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdFeatureFlagLimitsResult = objectOf({
  active_flags: number,
  allotted_feature_flags: number,
});
